import { useEffect, useMemo } from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import { RadioGroup } from '@restworld/ui-ds-base';
import { useVariableOptions } from '@restworld/utils-common';

import {
  saveResearchErrorReturnAtom,
  UserUnsubscribeReason,
  userUnsubscribeReasonAtom,
  userUnsubscribeReasonFreeTextAtom,
} from './save-research-tab.atoms';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ISavedResearchUnSubscribeReasonProps {}

const SavedResearchUnSubscribeReason: React.FunctionComponent<ISavedResearchUnSubscribeReasonProps> = (props) => {
  const { fetchVariable, variableOptions } = useVariableOptions();

  const [usersUnsubscribeReason, setUsersUnsubscribeReason] = useAtom(userUnsubscribeReasonAtom);
  const [userUnsubscribeReasonFreeText, setUserUnsubscribeReasonFreeText] = useAtom(userUnsubscribeReasonFreeTextAtom);
  const [saveResearchErrorReturn, setSaveResearchErrorReturn] = useAtom(saveResearchErrorReturnAtom);

  useEffect(() => {
    fetchVariable(['worker_jp_saved_research_unsubscribe_reason']);
  }, [fetchVariable]);

  const options = useMemo(
    () => [
      ...(variableOptions['worker_jp_saved_research_unsubscribe_reason'] ?? []),
      ...[
        {
          id: 'other',
          key: 'other',
          label: 'Altro',
        },
      ],
    ],
    [variableOptions]
  );
  const { t } = useTranslation('user-settings');
  return (
    <div className="flex flex-col items-start pt-4 w-full">
      <RadioGroup
        value={usersUnsubscribeReason}
        id="users_unsubscribe_reason"
        options={options}
        onChange={(value) => {
          setSaveResearchErrorReturn('');
          setUsersUnsubscribeReason(value as UserUnsubscribeReason);
        }}
        returnKey="id"
        inlineTextInputProps={{
          placeholder: t('write_the_reason'),
          id: 'other',
          value: userUnsubscribeReasonFreeText ?? '',
          onChange(value) {
            setUserUnsubscribeReasonFreeText(value);
          },
        }}
      />
      {saveResearchErrorReturn && <div className="text-red-500 text-sm pt-2">{saveResearchErrorReturn}</div>}
    </div>
  );
};

export default SavedResearchUnSubscribeReason;
